var _path, _path2, _g, _path3, _g2, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingBag2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 665,
    viewBox: "0 0 800 665",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_187)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M468.536 183.651H200.214L184.234 102.047C180.896 86.9218 167.401 75.1301 151.422 75.1301H33.6667C15.1302 75.1301 0 90.2603 0 108.797C0 127.26 15.1302 142.391 33.6667 142.391H123.651L190.979 481.453C194.318 499.068 201.917 515.047 212.854 527.687C232.172 508.37 258.24 497.432 287.714 497.432C333.948 497.432 373.51 526.833 388.635 568.099H476.135C491.266 526.833 530.823 497.432 577.057 497.432C607.385 497.432 635.083 510.005 654.474 531.026C666.266 517.604 674.646 501.62 677.984 483.937L712.5 327.474C693.964 333.37 674.646 335.927 654.474 335.927C563.635 335.927 487.073 270.302 468.536 183.651Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 226,
    y: 543,
    width: 124,
    height: 122
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.667 543.667H349.333V664.833H226.667V543.667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.078 604.25C349.078 637.703 322.016 664.833 288.568 664.833C255.115 664.833 227.984 637.703 227.984 604.25C227.984 570.797 255.115 543.667 288.568 543.667C322.016 543.667 349.078 570.797 349.078 604.25Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_106_187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 516,
    y: 543,
    width: 123,
    height: 122
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M516 543.667H638.667V664.833H516V543.667Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_106_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638.495 604.25C638.495 637.703 611.365 664.833 577.911 664.833C544.458 664.833 517.328 637.703 517.328 604.25C517.328 570.797 544.458 543.667 577.911 543.667C611.365 543.667 638.495 570.797 638.495 604.25Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M722.583 126.411L658.667 194.588C654.474 199.635 647.729 202.12 641.833 202.12C635.083 202.12 629.193 199.635 625.073 194.588L590.552 157.588C581.25 148.286 582.104 133.156 591.406 123.922C600.641 114.62 615.766 115.474 625.073 124.776L642.682 143.24L689.844 93.6666C699.078 84.3645 713.354 83.5103 723.437 92.8176C731.036 102.047 731.036 117.177 722.583 126.411ZM656.177 0.270752C576.276 0.270752 512.286 65.0468 512.286 144.094C512.286 223.213 577.057 287.984 656.177 287.984C735.229 287.984 800 223.213 800 144.094C800 65.0468 735.229 0.270752 656.177 0.270752Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 665,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag2);
export default __webpack_public_path__ + "static/media/shopping-bag2.c4c64dc8b872367979b37a94016652aa.svg";
export { ForwardRef as ReactComponent };